import React, { useContext } from "react";
import { TextField } from "@mui/material";
import GroupBDRBiologists from "../FieldTags/GroupBDRBiologists";
import { UserContext } from "../../context/UserContext";
import xplanLabels from "../../util/XplanLabels";
import ROLES from "../../util/roles";
import HistoryLogElement from "./HistoryLogElement";
import { checkRole } from "../../util/FormUtils";

const newPlan = window.location.pathname === "/xplans/new";

const RelabelingDetails = ({ relabelingDetails, handleChange, xplans, required }) => {
    const { user } = useContext(UserContext);
    const canEdit = checkRole(user, [ROLES.BIOLOGIST, ROLES.APPROVER]);

    return (
        <div id="relabelingDetails" className="planField">
            <GroupBDRBiologists />
            <TextField
                name="relabelingDetails"
                label={xplanLabels.relabelingDetails}
                InputLabelProps={{ shrink: true }}
                type="text"
                required={required.includes("relabelingDetails")}
                value={relabelingDetails ? relabelingDetails : ""}
                onChange={(e) => handleChange("relabelingDetails", e.target.value)}
                multiline
                minRows={1}
                className="fullLength"
                disabled={!canEdit}
            />
            {!newPlan && <HistoryLogElement xplans={xplans} label={"relabelingDetails"} />}
        </div>
    );
};

export default RelabelingDetails;